{
  "dropzoneLabel": "Zona spuštanja",
  "selectPlaceholder": "Odaberite stavku",
  "tableResizer": "Promjena veličine",
  "colorSwatchPicker": "Color swatches"
}
